import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/observable/fromEvent';
import { WINDOW } from './window.token';
export class WindowService {
/**
 * Observable of the window resize event
 */
resizeObs: Observable<any>;
private _height: number;
/**
 * @param {?} w
 */
constructor(
private w: Window) {
    this.resizeObs = Observable.fromEvent(w, 'resize');
  }
/**
 * Get the browsers window object
 * 
 * @return {?}
 */
get window() {
    return this.w;
  }
/**
 * Get the width of the window
 * 
 * @return {?}
 */
get width(): number {
    return this.w.innerWidth;
  }
/**
 * Return whether device is on a screen < 992px wide
 * 
 * @return {?}
 */
get isMobile() {
    return this.width < 992;
  }
/**
 * Get the height of the window
 * 
 * @return {?}
 */
get height(): number {
    return this._height ? this._height : this.w.innerHeight;
  }
/**
 * Set the height of the window
 * 
 * @param {?} height
 * @return {?}
 */
set height(height: number) {
    this._height = height;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Window, decorators: [{ type: Inject, args: [WINDOW, ] }, ]},
];
}

function WindowService_tsickle_Closure_declarations() {
/** @type {?} */
WindowService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WindowService.ctorParameters;
/**
 * Observable of the window resize event
 * @type {?}
 */
WindowService.prototype.resizeObs;
/** @type {?} */
WindowService.prototype._height;
/** @type {?} */
WindowService.prototype.w;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
